<template>
  <div class="terms-component pa-2 mx-2">
    <v-card-title class="pt-6 font-weight-bold">
      {{ $t('terms.terms.termsOfUse') }}
    </v-card-title>
    <div>
      <v-card-text style="min-height: 300px">
        <p>
          <strong>{{ $t('terms.terms.lastUpdated') }}</strong>
        </p>
        <p>
          {{ $t('terms.terms.termsText1') }}
          (“<u>{{ $t('terms.terms.termsCapital') }}</u
          >”)
          {{ $t('terms.terms.termsText2') }}
        </p>
        <!-- TODO: This will probably need to be reworked -->

        <p>
          <span>
            <div class="mt-3">
              {{ $t('terms.terms.termsText3') }}
            </div>
            <span>
              <div class="ml-5 mt-3">
                (i)
                {{ $t('terms.terms.termsText4') }}
                (“<u>{{ $t('terms.terms.endCustomer') }}</u
                >”),
              </div>
              <div class="ml-5 mt-3">
                (ii)
                {{ $t('terms.terms.termsText5') }}
                “<u>{{ $t('terms.terms.application') }}</u
                >”),
                {{ $t('terms.terms.termsText6') }}
                (“<u>{{ $t('terms.terms.dealer') }}</u
                >”),
                {{ $t('terms.terms.and') }}
              </div>
              <div class="ml-5 mt-3">
                (iii)
                {{ $t('terms.terms.termsText7') }}
                (“<u>{{ $t('terms.terms.authorizedUser') }}</u
                >”),
              </div>
              <div class="mt-3">
                {{ $t('terms.terms.termsText8') }}
                “<u>{{ $t('terms.terms.you') }}</u
                >”{{ $t('terms.terms.termsText9') }} (“<u>{{
                  $t('terms.terms.company')
                }}</u
                >”)
                {{ $t('terms.terms.termsText10') }}
                “<u>{{ $t('terms.terms.products') }}</u
                >”)
                {{ $t('terms.terms.termsText11') }}
                “<u>{{ $t('terms.terms.services') }}</u
                >”).
              </div>
            </span>
          </span>
        </p>

        <p>
          {{ $t('terms.terms.termsText12') }}
        </p>
        <p>
          {{ $t('terms.terms.termsText13') }}
        </p>
        <p>
          <span>
            <h3>
              1)
              <strong>{{ $t('terms.terms.termsText14') }}</strong>
            </h3>
            <div class="ml-5 mt-3">
              a)
              <span>
                {{ $t('terms.terms.termsText15') }}
              </span>
              <div class="ml-5 mt-3">
                i)
                {{ $t('terms.terms.termsText16') }}
                (“<u>{{ $t('terms.terms.motionVideo') }}</u
                >”,
                {{ $t('terms.terms.termsText17') }}
                (“<u>{{ $t('terms.terms.clips') }}</u
                >”)
                {{ $t('terms.terms.termsText18') }}
                “<u>{{ $t('terms.terms.cases') }}</u
                >”);
              </div>
              <div class="ml-5 mt-3">
                ii)
                {{ $t('terms.terms.termsText19') }}
              </div>
              <div class="ml-5 mt-3">
                iii)
                {{ $t('terms.terms.termsText20') }}
              </div>
              <div class="ml-5 mt-3">
                iv)
                {{ $t('terms.terms.termsText21') }}
              </div>
              <div class="ml-5 mt-3">
                v)
                {{ $t('terms.terms.termsText22') }}
              </div>
              <div class="ml-5 mt-3">
                vi)
                {{ $t('terms.terms.termsText23') }}
              </div>
              <div class="ml-5 mt-3">
                vii)
                {{ $t('terms.terms.termsText24') }}
              </div>
              <div class="ml-5 mt-3">
                viii)
                {{ $t('terms.terms.termsText25') }}
              </div>
              <div class="ml-5 mt-3">
                ix)
                {{ $t('terms.terms.termsText26') }}
                (“{{ $t('terms.terms.caseSharing') }}”):
                {{ $t('terms.terms.and') }}
              </div>
              <div class="ml-5 mt-3">
                x)
                {{ $t('terms.terms.termsText27') }}
                (“{{ $t('terms.terms.tokenSharing') }}”).
              </div>
              <div class="ml-5 mt-3">
                {{ $t('terms.terms.termsText28') }}
                <strong>
                  {{ $t('terms.terms.termsText29') }}
                </strong>
              </div>
            </div>
            <div class="ml-5 mt-3">
              b)
              <span>
                {{ $t('terms.terms.termsText30') }}
                (“{{ $t('terms.terms.nvr') }}”).
                {{ $t('terms.terms.termsText31') }}
              </span>
              <div class="ml-5 mt-3">
                i)
                {{ $t('terms.terms.termsText32') }}
              </div>
              <div class="ml-5 mt-3">
                ii)
                {{ $t('terms.terms.termsText33') }}
              </div>
              <div class="ml-5 mt-3">
                iii)
                {{ $t('terms.terms.termsText34') }}
              </div>
              <div class="ml-5 mt-3">
                iv)
                {{ $t('terms.terms.termsText35') }}
              </div>
              <div class="ml-5 mt-3">
                {{ $t('terms.terms.termsText36') }}
              </div>
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              2)
              <strong>
                {{ $t('terms.terms.termsText37') }}
              </strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText38') }}
            </div>
            <div class="ml-5 mt-3">
              <div>
                a)
                <span>
                  {{ $t('terms.terms.termsText39') }}
                </span>
              </div>
              <div class="mt-3">
                b)
                <span>
                  {{ $t('terms.terms.termsText40') }}
                </span>
              </div>
              <div class="mt-3">
                c)
                <span>
                  {{ $t('terms.terms.termsText41') }}
                </span>
              </div>
              <div class="mt-3">
                d)
                <span>
                  {{ $t('terms.terms.termsText42') }}
                </span>
              </div>
              <div class="mt-3">
                e)
                <span>
                  {{ $t('terms.terms.termsText43') }}
                </span>
              </div>
              <div class="mt-3">
                f)
                <span>
                  {{ $t('terms.terms.termsText44') }}
                </span>
              </div>
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              3)
              <strong>{{ $t('terms.terms.subscriptions') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText45') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              4)
              <strong>{{ $t('terms.terms.termsText46') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              A)
              <span class="font-weight-bold font-italic">
                {{ $t('terms.terms.dealers') }}.
              </span>
              {{ $t('terms.terms.termsText47') }}
              (“<u>{{ $t('terms.terms.supportServices') }}</u
              >”).
              {{ $t('terms.terms.termsText48') }}
              <div class="mt-3">
                {{ $t('terms.terms.termsText49') }}
              </div>
            </div>
            <div class="ml-4 mt-3">
              B)
              <span class="font-weight-bold font-italic">
                {{ $t('terms.terms.termsText50') }}.
              </span>
              {{ $t('terms.terms.termsText51') }}
              {{ $t('terms.terms.termsText52') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              5) <strong>{{ $t('terms.terms.termsText53') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText54') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              6) <strong>{{ $t('terms.terms.termsText55') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText56') }}
              <strong>{{ $t('terms.terms.termsText56Bold') }}</strong>
              {{ $t('terms.terms.termsText56part2') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              7)
              <strong>{{ $t('terms.terms.termsText57') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText58') }}
              <strong>{{ $t('terms.terms.termsText59') }}</strong>
              {{ $t('terms.terms.termsText60') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              8)
              <strong>{{ $t('terms.terms.termsText61') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText62') }}
            </div>
            <div class="ml-5 mt-3">
              <div>
                a)
                <span>
                  {{ $t('terms.terms.a') }}
                  “<u>{{ $t('terms.terms.deletedAndReassigned') }}</u
                  >”
                  {{ $t('terms.terms.termsText63') }}
                </span>
              </div>
              <div>
                b)
                <span>
                  {{ $t('terms.terms.a') }}
                  “<u>{{ $t('terms.terms.moved') }}</u
                  >”
                  {{ $t('terms.terms.termsText64') }}
                </span>
              </div>
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              9)
              <strong>{{ $t('terms.terms.termsText65') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText66') }}
              {{ $t('terms.terms.termsText67') }}
            </div>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText68') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              10)
              <strong> {{ $t('terms.terms.termsText69') }} </strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText70') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              11)
              <strong>{{ $t('terms.terms.termsText71') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText72') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              12)
              <strong>{{ $t('terms.terms.termsText73') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText74') }}
            </div>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText75') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              13)
              <strong>{{ $t('terms.terms.termsText76') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText77') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              14)
              <strong>{{ $t('terms.terms.termsText78') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText79') }}
              (a)
              {{ $t('terms.terms.termsText80') }}
              (b)
              {{ $t('terms.terms.termsText81') }}
              (c)
              {{ $t('terms.terms.termsText82') }}
              (d)
              {{ $t('terms.terms.termsText83') }}
              (e)
              {{ $t('terms.terms.termsText84') }}
              (f)
              {{ $t('terms.terms.termsText85') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              15)
              <strong>{{ $t('terms.terms.termsText86') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText87') }}
              (“<u>{{ $t('terms.terms.term') }}</u
              >”).
              {{ $t('terms.terms.termsText88') }}
            </div>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText89') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              16)
              <strong>{{ $t('terms.terms.termsText90') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText91') }}
            </div>
            <!-- using raw text for now, until we find a better way of handling terms text via tags -->
            <div class="ml-4 mt-3">
              All information that relates to an identified or identifiable
              natural person (personal data) collected by Company through or in
              connection with the Services for Company’s own purposes (i.e., as
              controller) is subject to the VIGIL CLOUD Privacy Policy at
              <a
                class="link"
                href="https://vigilcloud.3xlogic.com/vigil-cloud-privacy-policy"
                rel="noopener"
                target="_blank"
              >
                https://vigilcloud.3xlogic.com/vigil-cloud-privacy-policy
              </a>
              and the Securitas Global Privacy Policy at
              <a
                class="link"
                href="https://www.securitas.com/en/about-us/securitas-technology-and-healthcare-global-privacy-policy"
                rel="noopener"
                target="_blank"
              >
                https://www.securitas.com/en/about-us/securitas-technology-and-healthcare-global-privacy-policy/
              </a>
              .
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              17)
              <strong>{{ $t('terms.terms.updates') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText94') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              18)
              <strong>{{ $t('terms.terms.termsText95') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText96') }}
            </div>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText97') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              19)
              <strong>{{ $t('terms.terms.termsText98') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText99') }}
              “<u>{{ $t('terms.terms.companyParties') }}”</u>)
              {{ $t('terms.terms.termsText100') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              20)
              <strong>{{ $t('terms.terms.termsText101') }}</strong>
            </h3>
            <div class="ml-5 mt-3">
              <div>
                a.
                <span>
                  <span class="font-weight-bold font-italic">{{
                    $t('terms.terms.termsText102')
                  }}</span>
                  {{ $t('terms.terms.termsText103') }}
                </span>
              </div>
              <div class="mt-3">
                b.
                <span>
                  <span class="font-weight-bold font-italic">{{
                    $t('terms.terms.termsText104')
                  }}</span>
                  {{ $t('terms.terms.termsText105') }}
                </span>
              </div>
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              21)
              <strong>{{ $t('terms.terms.indemnification') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText106') }}
              “<u>{{ $t('terms.terms.termsText107') }}</u
              >”)
              {{ $t('terms.terms.termsText108') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              22)
              <strong>{{ $t('terms.terms.termsText109') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText110') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              23)
              <strong>{{ $t('terms.terms.thirdPartyLinks') }}</strong>
            </h3>
            <div class="ml-4 mt-3">
              {{ $t('terms.terms.termsText111') }}
            </div>
          </span>
        </p>
        <p>
          <span>
            <h3>
              24)
              <strong>{{ $t('terms.terms.miscellaneous') }}</strong>
            </h3>
            <div class="ml-5">
              <div class="mt-3">
                a.
                <span class="font-weight-bold font-italic"
                  >{{ $t('terms.terms.termsText112') }}
                </span>
                {{ $t('terms.terms.termsText113') }}
              </div>
              <div class="mt-3">
                b.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.termsText114') }}</span
                >
                {{ $t('terms.terms.termsText115') }}
              </div>
              <div class="mt-3">
                c.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.termsText116') }}
                </span>
                {{ $t('terms.terms.termsText117') }}
              </div>
              <div class="mt-3">
                d.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.termsText118') }}
                </span>
                {{ $t('terms.terms.termsText119') }}
              </div>
              <div class="mt-3">
                e.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.termsText120') }}</span
                >
                {{ $t('terms.terms.termsText121') }}
              </div>
              <div class="mt-3">
                f.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.termsText122') }}
                </span>
                <div class="ml-5">
                  i.
                  {{ $t('terms.terms.termsText123') }}
                  <br />
                  ii.
                  {{ $t('terms.terms.termsText124') }}
                </div>
              </div>
              <div class="mt-3">
                g.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.termsText125') }}
                </span>
                {{ $t('terms.terms.termsText126') }}
              </div>
              <div class="mt-3">
                h.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.termsText127') }}</span
                >
                {{ $t('terms.terms.termsText128') }}
              </div>
              <div class="mt-3">
                i.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.language') }}.
                </span>
                {{ $t('terms.terms.termsText129') }}
              </div>
              <div class="mt-3">
                j.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.termsText130') }}
                </span>
                {{ $t('terms.terms.termsText131') }}
                (“<u>{{ $t('terms.terms.termsText132') }}</u
                >”)
                {{ $t('terms.terms.termsText133') }}
                (“<u>{{ $t('terms.terms.termsText134') }}</u
                >”).
                {{ $t('terms.terms.termsText135') }}
              </div>
              <div class="mt-3">
                k.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.termsText136') }}
                </span>
                <div class="ml-5">
                  i.
                  {{ $t('terms.terms.termsText137') }}
                  (“<u>{{ $t('terms.terms.laws') }}</u
                  >”),
                  {{ $t('terms.terms.termsText138') }}
                  <br />
                  ii.
                  {{ $t('terms.terms.termsText139') }}
                  <br />
                  iii.
                  {{ $t('terms.terms.termsText140') }}
                  <br />
                  iv.

                  {{ $t('terms.terms.termsAppText') }}“<u>{{
                    $t('terms.terms.recordingLaws')
                  }}</u
                  >”).

                  {{ $t('terms.terms.termsTextRecordingLaws') }}

                  <br />
                  v.
                  {{ $t('terms.terms.termsText141') }}
                  “<u>{{ $t('terms.terms.permits') }}</u
                  >”);
                  {{ $t('terms.terms.termsText142') }}
                </div>
              </div>
              <div class="mt-3">
                l.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.severability') }}</span
                >.
                {{ $t('terms.terms.termsText143') }}
              </div>
              <div class="mt-3">
                m.<span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.construction') }}</span
                >.
                {{ $t('terms.terms.termsText144') }}
              </div>
              <div class="mt-3">
                n.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.termsText145') }}
                </span>
                {{ $t('terms.terms.termsText146') }}
              </div>
              <div class="mt-3">
                o.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.termsText147') }}</span
                >
                {{ $t('terms.terms.termsText148') }}
              </div>
              <div class="mt-3">
                p.
                <span class="font-weight-bold font-italic">
                  {{ $t('terms.terms.termsText149') }}
                </span>
                {{ $t('terms.terms.termsText150') }}
              </div>
            </div>
          </span>
        </p>
        <div class="ml-4 mt-3">US.131185956.06</div>
        <v-checkbox
          v-if="!termsPage"
          v-show="!userClickOpen"
          primary
          hide-details
          type="checkbox"
          :input-value="termsAgreed"
          @click="acceptTerms"
          class="ml-5"
          data-testid="terms-accept-checkbox"
        >
          <template v-slot:label>
            <div class="text--primary">
              {{ $t('terms.terms.agreeText1') }}
              {{ $t('terms.terms.agreeText2') }}.
              {{ $t('terms.terms.agreeText3') }}
              <router-link
                :to="{ name: 'PrivacyPolicy' }"
                class="link"
                @click.native.stop
                target="_blank"
              >
                {{ $t('terms.terms.agreeText4') }}
              </router-link>
              {{ $t('terms.terms.agreeText5') }}
              <a
                class="link"
                href="https://www.securitas.com/en/about-us/securitas-technology-and-healthcare-global-privacy-policy"
                rel="noopener"
                @click.stop
                target="_blank"
              >
                {{ $t('terms.terms.agreeText6') }} </a
              >.
            </div>
          </template>
        </v-checkbox>
      </v-card-text>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TermsComponent',
  props: {
    termsAgreed: {
      type: Boolean,
      required: true,
    },
    termsPage: {
      type: Boolean,
      required: false,
    },
    userClickOpen: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    acceptTerms() {
      this.$emit('acceptTerms', !this.termsAgreed)
    },
    scrollTop() {
      this.$vuetify.goTo('.terms-component', {
        container: '.text-card',
        duration: 0,
      })
    },
  },
  mounted() {
    this.scrollTop()
  },
})
</script>
<style lang="scss">
.terms-component {
  .link {
    color: #0091ff;
    &:hover {
      color: white;
    }
  }
}
</style>
